export default __webpack_public_path__ + "static/media/logo.13245fa0.png";